import React, { useMemo } from 'react';

interface Star {
  id: number;
  x: number;
  y: number;
  size: number;
  duration: number;
  delay: number;
}

const StarField: React.FC = () => {
  const stars = useMemo<Star[]>(() => {
    return Array.from({ length: 80 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2 + 0.5,
      duration: Math.random() * 4 + 2,
      delay: Math.random() * 4,
    }));
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {/* Nebula blobs */}
      <div
        className="nebula-1 absolute w-[600px] h-[600px] rounded-full -top-32 -left-32 opacity-60"
        style={{ animation: 'float 12s ease-in-out infinite' }}
      />
      <div
        className="nebula-2 absolute w-[500px] h-[500px] rounded-full top-1/2 -right-48 opacity-50"
        style={{ animation: 'float 15s ease-in-out infinite reverse' }}
      />
      <div
        className="nebula-3 absolute w-[400px] h-[400px] rounded-full -bottom-32 left-1/4 opacity-40"
        style={{ animation: 'float 10s ease-in-out infinite 2s' }}
      />

      {/* Twinkling stars */}
      {stars.map(star => (
        <div
          key={star.id}
          className="star"
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            '--duration': `${star.duration}s`,
            '--delay': `${star.delay}s`,
          } as React.CSSProperties}
        />
      ))}
    </div>
  );
};

export default StarField;
